import store from '@/store/index';

export default {
  // Set current devices/stream state
  setStreamConfig() {
    if ((!this.enableAudio && this.localAudioTrack) || store.getters.isWarmUpPeriod) {
      this.localAudioTrack.getMediaStreamTrack().enabled = false;
    }

    if (!this.enableVideo && this.localVideoTrack && !this.constraints.screen) {
      this.localVideoTrack.getMediaStreamTrack().enabled = false;
    }
  }
}

